import { useEffect, useState } from "react";
import { Col, Modal, Offcanvas, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getCommunicationMailDataStart } from "../../Store/Slices/promptSlice";
import { getCompanyListStart } from "../../Store/Slices/organizationSlice";
import { formatDateTime, formatDayDateTime } from "../DateFn";
import Loader from "../Loader";
import { getItem } from "../../Services/localService";
import { Link } from 'react-router-dom';
import { getRedirectURIStart } from '../../Store/Slices/promptSlice';
import { VscReply, VscArrowRight } from "react-icons/vsc";
import { LucideSendHorizontal, Trash2, Trash2Icon } from "lucide-react";
import { ScheduleModal } from "../EmailComposer/modals";
import { MdDeleteOutline } from "react-icons/md";
import CreatableSelect from 'react-select/creatable'
import TextEditor from "./editor";
import { CgToolbarTop } from "react-icons/cg";
import { LuReply, LuForward } from "react-icons/lu";


const Emails = ({ showEmailModal, setShowEmailModal, selectedRowDataToViewMail, formsubmodules }) => {
    let user = getItem('user')
    let currentUser = useSelector((state) => state?.user);
    let currentUserEmail = currentUser?.userData?.email;
    let orgId = getItem('organization')
    let currentOrg = useSelector((state) => state?.org);
    let accessURL = currentOrg?.companyData[0]?.access_url;
    const dispatch = useDispatch();
    let AiResponse = useSelector((state) => state?.prompt);
    let mailsList = AiResponse?.communicationMailData;
    let [selectedIndex, setSelectedIndex] = useState(0);
    const getRedirectURI = useSelector((state) => state?.prompt?.message?.redirect_uri);
    let [showReply, setShowReply] = useState(false);
    let [showScheduleModal, setShowScheduleModal] = useState(false);
    let [showToolbar, setShowToolbar] = useState(false);
    let [isRead, setIsRead] = useState(false);
    let [showDeleteWarning, setShowDeleteWarning] = useState(false);

    let initialContent = `<p>Dear <strong>Priya vj</strong>,</p><br/>
      <p class="mb-3">
        Thank you for your interest! Could you let me know what specific features or information you’re looking for? 
        I’d be happy to assist.
      </p><br/>
      <p class="mb-0">Thanks,</p>
      <p class="fw-semibold">Dhavapriya Vadivel</p>`;

    let [content, setContent] = useState(initialContent);

    let [selectedOptions, setSelectedOptions] = useState([]);
    let [options, setOptions] = useState([]);
    let [showCc, setShowCc] = useState(false);
    let [showBcc, setShowBcc] = useState(false);

    useEffect(() => {
        if (mailsList?.length && selectedIndex >= 0) {
            setOptions([]); setSelectedOptions([]);
            const newOption = { value: mailsList?.[selectedIndex]?.from_email, label: mailsList?.[selectedIndex]?.from_email };
            setOptions((prev) => [...prev, newOption]);
            setSelectedOptions((prev) => [...prev, newOption]);
        }
    }, [selectedIndex])

    useEffect(() => {
        dispatch(getRedirectURIStart({ id: currentUserEmail }));
    }, [currentUserEmail])
    //    useEffect(() => {
    //      const mailData = {
    //        senderEmail: user?.email,
    //        ...(formsubmodules === 'Prospects' 
    //          ? { company: selectedRowDataToViewMail?.Company_Name }
    //          : { receiverEmail: selectedRowDataToViewMail?.Email }),
    //      };
    //      console.log("mailData", mailData);
    //      dispatch(getCommunicationMailDataStart(mailData));
    //    }, []);
    useEffect(() => {
        dispatch(getCompanyListStart(orgId));
    }, []);

    useEffect(() => {
        const mailData = {
            senderEmail: user?.email,
            ...(formsubmodules === 'Prospects'
                ? { company: selectedRowDataToViewMail?.Company_Name }
                : formsubmodules === 'Leads'
                    ? { company: selectedRowDataToViewMail?.Company }
                    : {}),
        };
        console.log("mailData", mailData);
        dispatch(getCommunicationMailDataStart(mailData));
    }, []);

    const formatName = (mailId) => {
        if (mailId) {
            const name = mailId?.split('@')?.[0];
            const formattedName = name
                .split('.')
                .map(nm => nm.charAt(0).toUpperCase() + nm.slice(1))
                .join(' ');
            return formattedName;
        } else return "";
    }

    const handleShowScheduleEmail = () => {
        setShowScheduleModal(true);
    }

    const handleScheduleEmail = () => {
        setShowScheduleModal(false);
    }

    const isOnlyHTML = (value) => {
        if (!value) return false;
        const parser = new DOMParser();
        const doc = parser.parseFromString(value, "text/html");
        const text = doc.body.textContent?.trim();
        return text === "";
    };

    const handleDelete = () => {
        if (isOnlyHTML(content))
            setShowReply(false);
        else
            setShowDeleteWarning(true);
    }

    return (
        <>
            <Offcanvas placement='end'
                show={showEmailModal}
                onHide={() => { setShowEmailModal(false); }}
                className="emails timeline-offcanvas"
                backdrop={true}
                scroll={false}>
                <Offcanvas.Header closeButton className="pb-2 position-relative">
                    <Offcanvas.Title>Email</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="vh-100" style={{ overflow: 'scroll' }}>
                    <Loader isVisible={AiResponse?.isLoading} isModal={true} overall={false} />
                    <Row className="vh-100">
                        <div className="col-3"
                            style={{ padding: '0 2px 0 0' }}
                        >
                            {mailsList?.length > 0 && mailsList?.map((data, index) => (//index !== 0 && 
                                <div className="cursor-pointer" style={{ padding: '5px 10px', border: '1px solid lightgrey', borderLeft: index === selectedIndex ? '4px solid rgb(15,108,189)' : '4px solid rgb(154,191,220)' }}
                                    onClick={() => { setSelectedIndex(index); setIsRead(index === 1 ? true : false) }}>
                                    <Row>
                                        <div className="col-2">
                                            <div style={{
                                                width: 40,
                                                height: 40,
                                                borderRadius: '50%',
                                                backgroundColor: 'rgb(154,191,220)',
                                                color: 'rgb(53,76,90)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontWeight: 'bold',
                                                fontSize: 18,
                                            }}>
                                                {data.from_email ? data.from_email.charAt(0).toUpperCase() : ''}
                                            </div>
                                        </div>
                                        <div className="col-10">
                                            {index === 1 && !isRead ?
                                                <div className="fw-semibold">{formatName(data.from_email)}
                                                    <span className="new-mail-badge">1</span>
                                                </div>
                                                : <div className="fw-semibold">{formatName(data.from_email)}
                                                </div>
                                            }
                                            <div>
                                                <p className="mb-1" style={{
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    width: 'auto'
                                                }} >{data.subject}</p><span className="fs-12 float-end">{formatDateTime(data.updatedAt)}</span>
                                            </div>
                                            {/* <div style={{
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                width: 'auto'
                                            }} dangerouslySetInnerHTML={{ __html: data.message }}></div> */}
                                        </div>
                                    </Row>
                                </div>
                            ))}
                        </div>
                        {mailsList?.length > 0 ? (
                            <div className="col-9 p-2" style={{ backgroundColor: 'rgb(245,245,245)' }}>
                                <>
                                    <div className="card shadow-sm">
                                        <div className="fw-bold">{mailsList?.[selectedIndex]?.subject}</div>
                                    </div>
                                    {showReply &&
                                        <div className="card mt-2 shadow-sm">
                                            <Row className="reply-hover mb-2">
                                                <div className="col-10">
                                                    <div className="dropdown">
                                                        <div className="btn-group btn-group-sm">
                                                            <button type="button" className="btn btn-primary me-0 px-2 rounded-start btn-digy-dark">
                                                                <LucideSendHorizontal className="me-1" height={16} width={16} />Send
                                                            </button>
                                                            <button type="button" className="btn btn-primary btn-digy-dark dropdown-toggle dropdown-toggle-split rounded-end pe-2" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i className="fa fa-caret-down"></i>
                                                                <span className="visually-hidden">Toggle Dropdown</span>
                                                            </button>
                                                            <ul className="dropdown-menu p-0 shadow" aria-labelledby="dropdownMenuButton1">
                                                                <li><a className="dropdown-item -link-primary py-2" role='button'>Send</a></li>
                                                                <li><a className="dropdown-item -link-primary py-2" role='button'
                                                                    onClick={() => handleShowScheduleEmail()}>Schedule Send</a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-2 d-flex align-items-center justify-content-center reply-hover-icon">
                                                    <MdDeleteOutline className="fs-20 cursor-pointer" title="Discard" onClick={() => handleDelete()} />
                                                </div>
                                            </Row>
                                            <Row>
                                                <hr className="m-0" />
                                                <div className="col-12 setup-actions d-flex pb-2 pt-2">
                                                    <Row className="m-0 w-100">
                                                        <div className="col-1 d-flex justify-content-center align-items-center">To</div>
                                                        <div className="col-9 d-flex align-items-center">
                                                            <CreatableSelect
                                                                isMulti
                                                                placeholder="Enter email..."
                                                                options={options}
                                                                value={selectedOptions}
                                                                // onInputChange={handleInputChange}
                                                                // onChange={handleChange}
                                                                // onCreateOption={handleCreateOption}
                                                                // inputValue={mailsList?.[selectedIndex]?.to_email}
                                                                // onBlur={handleBlurToAddress}
                                                                isClearable
                                                                noOptionsMessage={() => "No matching users"}
                                                            />
                                                        </div>
                                                        <div className="col-2  d-flex justify-content-center align-items-center">
                                                            <span className={`fw-semibold text-primary me-3 cursor-pointer ${showCc && 'd-none'}`}
                                                                onClick={() => setShowCc(true)}
                                                            >CC</span>
                                                            <span className={`fw-semibold text-primary me-3 cursor-pointer ${showBcc && 'd-none'}`}
                                                                onClick={() => setShowBcc(true)}
                                                            >BCC</span>
                                                        </div>
                                                    </Row>
                                                </div>
                                                <hr className="m-0" />
                                                {showCc &&
                                                    <>
                                                        <div className="col-12 setup-actions d-flex pb-2 pt-2">
                                                            <Row className="m-0 w-100 reply-hover">
                                                                <div className="col-1 d-flex justify-content-center align-items-center">Cc</div>
                                                                <div className="col-9 d-flex align-items-center">
                                                                    <CreatableSelect
                                                                        isMulti
                                                                        placeholder="Enter email..."
                                                                        // options={optionsCc}
                                                                        // value={selectedOptionsCc}
                                                                        // onInputChange={handleInputChangeCc}
                                                                        // onChange={handleChangeCc}
                                                                        // onCreateOption={handleCreateOptionCc}
                                                                        // inputValue={inputCcValue}
                                                                        // onBlur={handleBlurCcAddress}
                                                                        isClearable
                                                                        noOptionsMessage={() => "No matching users"}
                                                                    />
                                                                </div>
                                                                <div className="col-2 d-flex justify-content-center align-items-center">
                                                                    <span className="fw-semibold text-primary me-3 cursor-pointer"
                                                                        onClick={() => setShowCc(false)}>X</span>
                                                                </div>
                                                            </Row>
                                                        </div>
                                                        <hr className="m-0" />
                                                    </>
                                                }
                                                {showBcc &&
                                                    <>
                                                        <div className="col-12 setup-actions d-flex pb-2 pt-2">
                                                            <Row className="m-0 w-100">
                                                                <div className="col-1 d-flex justify-content-center align-items-center">Bcc</div>
                                                                <div className="col-9 d-flex align-items-center">
                                                                    <CreatableSelect
                                                                        isMulti
                                                                        placeholder="Enter email..."
                                                                        // options={optionsBcc}
                                                                        // value={selectedOptionsBcc}
                                                                        // onInputChange={handleInputChangeBcc}
                                                                        // onChange={handleChangeBcc}
                                                                        // onCreateOption={handleCreateOptionBcc}
                                                                        // inputValue={inputBccValue}
                                                                        // onBlur={handleBlurBccAddress}
                                                                        isClearable
                                                                        noOptionsMessage={() => "No matching users"}
                                                                    />
                                                                </div>
                                                                <div className="col-2 d-flex justify-content-center align-items-center">
                                                                    <span className="fw-semibold text-primary me-3 cursor-pointer"
                                                                        onClick={() => setShowBcc(false)}>X</span>
                                                                </div>
                                                            </Row>
                                                        </div>
                                                        <hr className="m-0" />
                                                    </>
                                                }
                                                <div className="col-12 setup-actions d-flex pb-2 pt-2 reply-mail">
                                                    {/* <div className="float-end"><CgToolbarTop className="fs-16 cursor-pointer" onClick={() => setShowToolbar(!showToolbar)} /></div> */}
                                                    <TextEditor content={content} setContent={setContent} toolbar={true} />
                                                </div>
                                            </Row>
                                        </div>
                                    }
                                    <div className="card mt-2 shadow-sm">
                                        <Row>
                                            <div className="col-1">
                                                <div style={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: '50%',
                                                    backgroundColor: 'rgb(166,233,237)',
                                                    color: 'rgb(10,110,116)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontWeight: 'bold',
                                                    fontSize: 18,
                                                }}>
                                                    {mailsList?.[selectedIndex]?.from_email ? mailsList?.[selectedIndex]?.from_email.charAt(0).toUpperCase() : ''}
                                                </div>
                                            </div>
                                            <div className="col-11">
                                                <div>{formatName(mailsList?.[selectedIndex]?.from_email) + ' <' + mailsList?.[selectedIndex]?.from_email + '>'}
                                                    <span className="mail-reply" title="Reply" onClick={() => setShowReply(true)}><VscReply /></span>
                                                </div>
                                                <div className="mt-1">To: {mailsList?.[selectedIndex]?.to_email}
                                                    <span className="float-end fs-13">{formatDayDateTime(mailsList?.[selectedIndex]?.updatedAt)}</span>
                                                </div>
                                                {/* <div className="mt-1">To: {mailsList?.[selectedIndex]?.to_email?.join(', ')}</div> */}
                                                <div className="mt-3" dangerouslySetInnerHTML={{ __html: mailsList?.[selectedIndex]?.body }}></div>
                                                <div className="d-flex mt-5">
                                                    <button class="btn btn-light btn-blue me-2 border" type="button"
                                                        title="Reply" onClick={() => setShowReply(true)}>
                                                        <LuReply className="me-1" />Reply</button>
                                                    <button class="btn btn-light btn-blue me-2 border" type="button"
                                                        title="Forward">
                                                        <LuForward className="me-1" />Forward</button>
                                                </div>
                                            </div>
                                        </Row>
                                    </div>
                                </>
                            </div>
                        ) : (
                            getRedirectURI === false ? (
                                <div className="col-9 p-2 d-flex justify-content-center align-items-center"
                                    style={{ backgroundColor: 'rgb(245,245,245)' }}>
                                    <p style={{ marginBottom: 10 }}>Mail not found</p>
                                </div>


                            ) : (
                                <div className="col-9 p-2 d-flex justify-content-center align-items-center"
                                    style={{ backgroundColor: 'rgb(245,245,245)' }}>
                                    <p style={{ marginBottom: 10 }}>Your Microsoft account is not integrated</p>
                                    <Link to={`/${accessURL}/settings/personal-settings/`}>
                                        <p style={{ marginLeft: -200, marginTop: 50 }}>Click here to integrate</p>
                                    </Link>
                                </div>
                            )
                        )}

                    </Row>
                </Offcanvas.Body>
            </Offcanvas>
            {showScheduleModal &&
                <ScheduleModal
                    showScheduleModal={showScheduleModal}
                    setShowScheduleModal={setShowScheduleModal}
                    handleSchedule={handleScheduleEmail}
                />
            }
            {showDeleteWarning &&
                <Modal
                    show={showDeleteWarning}
                    onHide={() => setShowDeleteWarning(false)}
                    backdrop="static"
                    keyboard={false}
                    className="modal-md"
                >
                    <Modal.Body>
                        <h4 className='pb-3'>Discard message</h4>
                        <p className='fw-semibold'>
                            Are you sure you want to discard this draft?
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            className="btn btn-outline-secondary flat-btn text-secondary"
                            onClick={() => setShowDeleteWarning(false)}
                            data-bs-dismiss="modal">
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger"
                            data-bs-dismiss="modal"
                            onClick={() => { setShowReply(false); setShowDeleteWarning(false) }}>
                            Ok
                        </button>
                    </Modal.Footer>
                </Modal>
            }
        </>
    )
}
export default Emails;